import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const CircleArrowsIcon: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--circle-arrows')}
    viewBox="0 0 16 21"
    xmlns="http://www.w3.org/2000/svg"
    data-icon={icon}
  >
    <path
      fill="none"
      stroke="#17171D"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="
        M4.6,16.7
        C1.2,15-0.2,10.9,1.4,7.4
        c1.4-2.8,4.5-4.3,7.4-3.8
        l1.3,0.2
      "
    />
    <polyline
      fill="none"
      stroke="#17171D"
      strokeMiterlimit="10"
      points="6.9,5.9 10.2,3.8 7.8,0.9 "
    />
    <path
      fill="none"
      stroke="#17171D"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="
        M11.4,4.2
        c3.4,1.7,4.8,5.9,3.1,9.3
        c-1.4,2.8-4.5,4.3-7.5,3.7
        l-1.3-0.2
      "
    />
    <polyline
      fill="none"
      stroke="#17171D"
      strokeMiterlimit="10"
      points="9,15 5.8,17.1 8.1,20 "
    />
  </svg>
);
export default CircleArrowsIcon;
